import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import Column from '@/util/Column';
import ViewRef from '@/util/ViewRef';
import { Aliases } from '@/features/addWidgetModal/queryColumnsApi';
import { getColumnType } from '@/components/modals/ModalAddWidget/helpers';
import { TrevorComponent } from '@trevor/ui-components';
import { useColumnFilter } from '@/components/modals/ModalAddWidget/subcomponents/useColumnFilter';
import { Filter, FilterName } from '../styled-components';
import SelectDashboardFilterColumn from '../../../SelectDashboardFilterColumn';

export type ColumnFilterProps = {
  aliases: Aliases;
  selectedSavedQuery: ViewRef;
  queryColumns: Column[];
};

const ColumnFilterRaw: TrevorComponent<ColumnFilterProps> = ({
  className,
  aliases,
  selectedSavedQuery,
  queryColumns,
}) => {
  const [filters, selectedColumns, selectColumn, removeColumn] =
    useColumnFilter(selectedSavedQuery);

  return filters.length ? (
    <div className={className}>
      <p>Select the column each filter should apply to</p>
      {filters.map((f, index) => (
        <Filter key={f._id}>
          <FilterName>
            <FontAwesomeIcon icon="filter" />
            {f.name()}
          </FilterName>
          <SelectDashboardFilterColumn
            types={getColumnType(f)}
            selectedCol={selectedColumns[index] ?? null}
            columns={queryColumns}
            onClick={selectColumn(index)}
            aliases={aliases}
            onRemove={removeColumn(index, f._id)}
          />
        </Filter>
      ))}
    </div>
  ) : null;
};

export const ColumnFilter = styled(ColumnFilterRaw)`
  display: flex;
  width: 100%;
  font-size: 13px;
  color: #37352f;
  background: #fff;
  flex-direction: column;
  label {
    span {
      font-style: italic;
      color: #ccc !important;
      font-size: 11px;
    }
  }
  p {
    padding-left: 2px;
    margin-bottom: 10px;
    font-size: 12px;
  }
`;
